<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageheader :title="title" :title1="title1" />

                <!-- /add -->
                <div class="card">
                    <div class="card-body">
                        <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
                        <div class="row">
                            <div class="d-flex align-items-center">

                                <div class="search-set "
                                    style="margin-top: 10px !important; margin-bottom: 0px !important;">

                                    <div class="search-input">
                                        <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                                alt="img" /></a>
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <label>
                                                <input type="search" class="form-control form-control-sm"
                                                    placeholder="Search..." aria-controls="DataTables_Table_0"
                                                    v-model="query" />
                                            </label>
                                        </div>
                                    </div>



                                </div>
                                <div class="wordset">
                                    <ul>
                                        <li>
                                            <div class="form-group"
                                                style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                                <div class="input-groupicon" style="z-index: 100;">
                                                    <DatePicker v-model:value="periode" type="date" range
                                                        format="YYYY-MM-DD" value-type="format" :clearable="true"
                                                        class="picker" style="width: 268px !important;" />
                                                </div>
                                            </div>
                                        </li>

                                        <li class="d-flex align-items-center gap-3">
                                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Generate"
                                                @click="generateData"
                                                class="d-flex flex-column justify-content-center  align-items-center mt-2 btn btn-primary p-1">
                                                <i class='bx bx-refresh' style="font-size: 25px;"></i>
                                            </a>

                                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                                @click="insert"
                                                class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1 mt-2"><img
                                                    src="../../../assets/img/Import_fill.png" alt="img" width="25" />
                                            </a>

                                        </li>




                                    </ul>
                                </div>

                            </div>

                            <div class="table-responsive mt-3">
                                <a-table :columns="columns" :data-source="filteredData">
                                    <!-- <template #bodyCell="{ column, record }">
                                        <template v-if="column.key === 'no'">
                                            <div class="productimgname">
                                                {{ record.no }}
                                            </div>
                                        </template>

</template> -->
                                </a-table>
                            </div>


                        </div>


                    </div>
                </div>
                <!-- /add -->
            </div>
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage } from "@/assets/js/function";
import { watch } from 'vue';

import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'


export default {
    // components: {
    //   Form,
    //   Field,
    // },
    components: {
        DatePicker

    },

    name: "editemployee",
    data() {
        return {
            filter: true,
            title: "Birthday Report",
            title1: "birthday report",
            config: "",
            api: "",

            // periode: new Date(),
            periode: [],

            data: [],

            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    align: "right",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },


                {
                    title: "Employee Name",
                    dataIndex: "nama",
                    key: "nama",
                    align: "left",
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama.toLowerCase();
                            b = b.nama.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },

                {
                    title: "DOB",
                    dataIndex: "dob",
                    key: "dob",
                    align: "left",
                    sorter: {
                        compare: (a, b) => {
                            a = a.dob.toLowerCase();
                            b = b.dob.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                
                {
                    title: "Phone Number",
                    dataIndex: "telepon",
                    key: "telepon",
                    align: "left",
                    sorter: {
                        compare: (a, b) => {
                            a = a.telepon.toLowerCase();
                            b = b.telepon.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },



                // {
                //     title: "Action",
                //     key: "action",
                //     sorter: false,
                // },
            ],

            //filter
            query: "",
            setting_break_button: "0",

            //data
            currentData: {
            },
            startDate: new Date,
            endDate: new Date,

            formatFilter: "EXCEL",
            FormatList: ["PDF", "EXCEL"],
        };
    },

    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: {
                Authorization: `Bearer ` + token,
            },
            timeout: 1200000,
        }
        
        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')

        // Set default date range (1st to last day of current month)
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // zero-based
        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);


        this.periode = [
            this.formatDateLocal(start),
            this.formatDateLocal(end),
        ];

    },

    mounted() {
        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },

    computed: {
        filteredData() {
            // If no query entered, return all data
            if (this.query === '') {
                return this.data;
            }

            const lowerCaseQuery = (this.query || '').toLowerCase();

            return this.data.filter(item => {
                return (
                    (item.name || '').toLowerCase().includes(lowerCaseQuery) ||
                    (item.date || '').toLowerCase().includes(lowerCaseQuery) ||
                    (item.phone || '').toLowerCase().includes(lowerCaseQuery) 
                    
                );
            });
        }
    },
    
    methods: {

        getNameFileUrl(url) {
            const parts = url.split('/');
            const fileName = parts[parts.length - 1];
            return fileName;
        },

        formatDateLocal(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },

        generateData() {
            this.index()
        },

        async insert() {
           
            let formData = new FormData();
            appendForm(formData)

            // Ensure periode has both start and end dates
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom", startDate);  // end date
                formData.append("dto", endDate);  // start date
            }

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading(); return;

            const api = base_url + '/v3/reports/birthday_excel';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;

            if(data.status){
                window.open(data.data.file_report, "_blank");
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

            
        },


        onDateChange(value) {
            this.periode = value;
            this.index();
        },

        async index() {
        
            let formData = new FormData();
            appendForm(formData)

            // Ensure periode has both start and end dates
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom", startDate);  // end date
                formData.append("dto", endDate);  // start date
            }

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading(); return;

            const api = base_url + '/v3/reports/birthday';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const birthdayReport = data.data.data_bday_report;
            // console.log('ini data overtime:', data)
            
            if(data.status){
                this.data = [];

                birthdayReport.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });

                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

           

        },

    },

};
</script>
